import {
  useIsMobile,
  WSElement,
  WSList,
  WSLoader,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import {
  PayeeRequirement,
  RequirementStatus
} from "@wingspanhq/wingspan-api-sdk";
import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { ExtendedRequirementPreviewList } from "../../../Requirements/components/ExtendedRequirementPreviewList";
import { ExtendedRequirementsTable } from "../../../Requirements/components/ExtendedRequirementsTable";
import {
  ExtendedRequirementTableItemData,
  RequirementAdditionalData,
  RequirementContextType,
  RequirementTableItemData
} from "../../../Requirements/types";

export type RouteClientsRequirementsProps = {
  requirements: ExtendedRequirementTableItemData[];
  isLoading: boolean;
};

export const RouteClientsRequirements: React.FC<
  RouteClientsRequirementsProps
> = ({ requirements, isLoading }) => {
  const isMobile = useIsMobile();
  const history = useHistory();

  const completedLength = useMemo(() => {
    return requirements.filter(e => e.status === RequirementStatus.COMPLETED)
      .length;
  }, [requirements]);

  const isRequirementsComplete = useMemo(() => {
    return requirements.every(e => e.status === RequirementStatus.COMPLETED);
  }, [requirements]);

  const [showPreviews, setShowPreviews] = useState(isMobile);

  const getOnViewDetails = (
    requirement: RequirementTableItemData,
    dataSource?: RequirementAdditionalData
  ) => {
    return requirement.id
      ? (item: PayeeRequirement) =>
          history.push(
            `/member/payers/${item.payerAccountId}/requirement/${item.id}`
          )
      : undefined;
  };

  return (
    <WSElement>
      <WSList gap="L">
        <WSSectionToolbar
          title="Requirements"
          pill={
            isLoading
              ? undefined
              : {
                  icon: true,
                  text: `${completedLength} of ${requirements.length} completed`,
                  theme: isRequirementsComplete ? "success" : "warning"
                }
          }
          buttons={[
            {
              label: "",
              onClick: () => setShowPreviews(true),
              kind: showPreviews ? "Secondary" : "Link",
              icon: "grid",
              onlyIcon: true,
              size: "S"
            },
            {
              label: "",
              onClick: () => setShowPreviews(false),
              kind: !showPreviews ? "Secondary" : "Link",
              icon: "list",
              onlyIcon: true,
              size: "S"
            }
          ]}
        />
        {isLoading ? (
          <WSLoader.Spinner size="M" />
        ) : showPreviews ? (
          <ExtendedRequirementPreviewList
            requirements={requirements}
            contextType={RequirementContextType.Payer}
            getOnViewDetails={getOnViewDetails}
            hideTaxVerificationConsent
          />
        ) : (
          <ExtendedRequirementsTable
            requirements={requirements}
            contextType={RequirementContextType.Payer}
            hideTaxVerificationConsent
            hideActions={false}
            getOnViewDetails={getOnViewDetails}
          />
        )}
      </WSList>
    </WSElement>
  );
};
